import React from 'react';
import styles from './index.module.scss';
import { useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ComplainDetail from './components/ComplainDetail';
import Breadcrumbs from '../../components/Breadcrumb';

const OrderComplain = () => {
  const { t } = useTranslation();

  let currentRoute = useRouteMatch();
  const detailMatch = useRouteMatch('/order-tracking/detail/order-complain');

  //render breadcrumb
  const breadcrumbNameMap = [
    { name: t('orderTracking.orderTracking'), path: '/order-tracking' },
    {
      name: t('orderTracking.orderDetail'),
      path: '/order-tracking/detail',
    },
    {
      name: 'Khiếu nại đơn hàng',
      path: '/order-tracking/detail/order-complain/review-complain',
    },
  ];

  //component
  return (
    <div className={styles['container']}>
      <Breadcrumbs breadcrumbNameMap={breadcrumbNameMap} currentRoute={currentRoute} />

      <div className={styles['content']}>{detailMatch && <ComplainDetail />}</div>
    </div>
  );
};

export default OrderComplain;
